<template>
  <!-- 公司简介 -->
  <div class="profile" :screenwidth="screenWidth">
    <basepanel>
      <!-- 主内容区导航 -->
      <el-tabs class="Tabs" v-model="activeName" @tab-click="handleClick" id="box1">
        <el-tab-pane label="公司概况" name="0"></el-tab-pane>
        <el-tab-pane label="经营理念" name="1"></el-tab-pane>
        <el-tab-pane label="业务范畴" name="2"></el-tab-pane>
        <el-tab-pane label="荣誉资质" name="3"></el-tab-pane>
      </el-tabs>

      <!-- 公司概况 -->
      <!-- <p class="box-p" v-if="isShow"  ></p> -->
      <div class="outer-box">
        <!-- <p :class="{'box-p':!isShow, 'box-p1': isShow}"></p> -->
        <panel :content="content[0]">
          <div slot="content">
            <div class="content wow fadeInUp">
              <!-- 轮播图 -->
              <div class="cont-item">
                <div class="cont-img cont-profile-img">
                  <img :src="profileContent.defineUrl" alt />
                </div>
                <div class="cont-detail">
                  <!-- <div class="cont-detail-bg"></div> -->
                  <h3 class="cont-title cont-title-left">{{ profileContent.subject }}</h3>
                  <p
                    class="cont-ctx-left"
                    v-html="profileContent.htmleditor"
                  >{{ profileContent.htmleditor }}</p>
                </div>
              </div>
              <!-- 重庆尚优科技有限公司 -->
              <div class="cont-item">
                <div class="cont-detail">
                  <!-- 重庆尚优 -->
                  <h3 class="cont-title-left">{{ companyContent.subject }}</h3>
                  <!-- 文字说明 -->
                  <p
                    class="cont-ctx-left"
                    v-html="companyContent.htmleditor"
                  >{{ companyContent.htmleditor }}</p>
                </div>
                <!-- 公司分布地图 -->
                <div class="cont-img">
                  <img :src="companyContent.defineUrl" alt />
                </div>
              </div>
            </div>
          </div>
        </panel>
      </div>

      <!-- 经营理念 -->

      <p class="box-p" id="box2"></p>
      <div class="outer-box">
        <!-- pc端 -->
        <panel :content="content[1]" v-show="conceptsImgph">   </panel>
          <div slot="content">
            <div class="content wow fadeInUp"  >
              <img class="item-img img1" :src="conceptsImgpc" alt  v-show="conceptsImgpc" />
              <img class="item-img img1" :src="conceptsImgph" alt  v-show="conceptsImgph"/>
            </div>
          </div>
      </div>

      <!-- 业务范畴 -->
      <div class="outer-box" id="box3">
        <p class="box-p"></p>
        <panel :content="content[3]">
          <div slot="content">
            <div class="content wow fadeInUp">
              <img class="item-img" :src="businessImg" alt />
            </div>
          </div>
        </panel>
      </div>

      <!-- 荣誉资质 -->
      <div class="outer-box" id="box4" @click="setSol">
        <p class="box-p"></p>
        <panel :content="content[2]">
          <div slot="content">
            <div class="content wow fadeInUp">
              <div class="honor-content">
                <ul class="honor-item">
                  <li v-for="(val, index) in qualificationsList" :key="index">
                    <router-link to="/honor?type=2">
                      {{
                      val.title
                      }}
                    </router-link>
                  </li>
                  <router-link class="more" to="/honor?type=2">
                    <span>更多荣誉</span>
                  </router-link>
                </ul>
                <div class="fg"></div>
                <ul class="honor-item">
                  <li v-for="(val, index) in honorList" :key="index">
                    <router-link to="/honor?type=1">
                      {{
                      val.title
                      }}
                    </router-link>
                  </li>
                  <router-link class="more" to="/honor?type=1">
                    <span>更多资质</span>
                  </router-link>
                </ul>
              </div>
            </div>
          </div>
        </panel>
      </div>
    </basepanel>
  </div>
</template>

<script>
import local from "../utils/local";
import panel from "../components/Panel";
import basepanel from "../components/BasePanel";
import { listNextWithFilter, view } from "../api/index";
import { WOW } from "wowjs";
export default {
  name: "profile",
  components: { panel, basepanel },
  data() {
    return {
       screenWidth: document.body.clientWidth,
      activeName: "0",
      isShow: false,
      content: [
        {
          titleCh: "公司概况",
          titleEn: "Profile",
          description: ""
        },
        {
          titleCh: "经营理念",
          titleEn: "Concepts",
          description: ""
        },
        {
          titleCh: "荣誉资质",
          titleEn: "Honor",
          description: ""
        },
        {
          titleCh: "业务范畴",
          titleEn: "Business",
          description: ""
        }
      ],

      url: require("../assets/images/public/empty.png"), //占位
      srcList: [],
      profileContent: {},
      companyContent: {},
      conceptsImgpc: "",
      conceptsImgph:"",
      businessImg: "",
      honorList: [],
      qualificationsList: []
    };
  },
  methods: {
    setSol() {
      local.set("sol", "profile")
    },
    srollbottom() {
      if(local.get("sol")=="profile"){
        window.scrollTo(0,document.body.scrollHeight);
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
      let _this = this;
      this.$nextTick(() => {
        if (tab.active == true && tab.index == "0") {
          _this.isShow = true;
          document.querySelector("#box1").scrollIntoView();
        } else if (tab.active == true && tab.index == "1") {
          document.querySelector("#box2").scrollIntoView();
        } else if (tab.active == true && tab.index == "2") {
          document.querySelector("#box3").scrollIntoView();
        } else {
          document.querySelector("#box4").scrollIntoView(true);
        }
      });
    },

    // 公司概况
    async getProfile() {
      let send = {
        url: {
          id: this.$map.aboutcompany
        }
      };
      let res = await view(send);
      if (res.type == "success") {
        let data = res.data.data;
        this.$set(data, "defineUrl", this.$srcHandle(data.imageclipper));
        this.profileContent = data;
      } else {
        console.log(res.msg);
      }
    },
    // 地区分布
    async getCompany() {
      let send = {
        url: {
          id: this.$map.companyregion
        }
      };
      let res = await view(send);
      if (res.type == "success") {
        let data = res.data.data;
        this.$set(data, "defineUrl", this.$srcHandle(data.imageclipper));
        this.companyContent = data;
      } else {
        console.log(res.msg);
      }
    },
    // 经营理念
    async getConcepts() {
      let send = {
        url: {
          id: this.$map.concepts
        }
      };
      let res = await view(send);
      if (res.type == "success") {
        if(this.pcshow){
          this.conceptsImgpc=this.$srcHandle(res.data.data.imageclipper);
        }else{
         this.conceptsImgph=this.$srcHandle(res.data.data.imageclipper_1);
        }
      } else {
        console.log(res.msg);
      }
    },
    // 业务范畴
    async getBusiness() {
      let send = {
        url: {
          id: this.$map.businessscope
        }
      };
      let res = await view(send);
      if (res.type == "success") {
        // this.businessImg = this.$srcHandle(res.data.data.imageclipper);
        if(this.pcshow){
          this.businessImg=this.$srcHandle(res.data.data.imageclipper);
        }else{
         this.businessImg=this.$srcHandle(res.data.data.imageclipper_1);
        }
      } else {
        console.log(res.msg);
      }
    },
    // 资质
    async getQualifications() {
      let send = {
        url: {
          page: 1,
          size: 6
        },
        data: {
          categoryIdList: [this.$map.honorcategoryId],
          needData: true
        }
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        let data = res.data;
        data.map(val => {
          this.$set(val, "defineUrls", [
            this.$srcHandle(val.data.imageclipper)
          ]);
        });
        this.qualificationsList = data;
      } else {
        console.log(res.msg);
      }
    },
    // 荣誉
    async getHonor() {
      let send = {
        url: {
          page: 1,
          size: 6
        },
        data: {
          categoryIdList: [this.$map.qualificationsId],
          needData: true
        }
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        let data = res.data;
        data.map(val => {
          this.$set(val, "defineUrls", [
            this.$srcHandle(val.data.imageclipper)
          ]);
        });
        this.honorList = data;
        new WOW().init();
      } else {
        console.log(res.msg);
      }
    }
  },
  mounted() {
    this.getProfile();
    this.getCompany();
    this.getConcepts();
    this.getBusiness();
    this.getQualifications();
    this.getHonor();
  },
  updated() {
    this.srollbottom()
  },
  computed: {
    //经营理念是pc端/phone端
    pcshow: function () {
      return this.screenWidth >= 1020 ? true : false;
    },
  phoneshow: function () {
      return this.screenWidth >=768? true : false;
    },
  },

};
</script>

<style scoped lang="less">
@import "../assets/less/public.less";
.profile {
  .box-p {
    height: 60px;
  }
  .box-p1 {
    height: 60px;
  }
  //内部的导航栏
  /deep/ .el-tabs__nav-scroll {
    width: 100% !important;
    max-width: 1200px;
    margin: auto;
    .el-tabs__nav {
      width: 100%;
      .el-tabs__item {
        width: 24%;
        text-align: center;
        padding: 0;
        color: #666666;
        &:hover {
          color: #0e6cb6;
        }
      }
      .el-tabs__item.is-active {
        color: #0e6cb6;
      }
      .el-tabs__active-bar {
        width: 20% !important;
        left: 2%;
        background-color: #0e6cb6;
      }
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    // .b2-word {
    //   display: none;
    // }
    .cont-item {
      display: flex;
      justify-content: space-between;
      text-decoration: none;
      align-items: center;
      &:hover {
        img {
          transform: scale(1.2);
        }
      }
      .cont-img {
        overflow: hidden;
        img {
          width: 100%;
          -webkit-transition: all 0.5s ease;
          -moz-transition: all 0.5s ease;
          -o-transition: all 0.5s ease;
          transition: all 0.5s ease;
        }
      }
      .cont-profile-img {
        position: relative;
        z-index: 2;
      }
      .cont-detail {
        position: relative;

        h3 {
          position: relative;
          color: #333333;
          // margin-top: 6vw;
          &:before {
            content: "";
            position: absolute;
            width: 5px;
            background-color: #0062c3;
          }
        }
        // .cont-title {
        //   // margin-top: 10vh;
        // }
        .cont-title-left {
          text-align: left;
        }
        p {
          color: #333333;
          opacity: 0.9;
        }
        .cont-ctx-left {
          text-align: left;
        }
      }
    }
    .item-img {
      width: 100%;
      height: 100%;
    }
    // 荣誉资质
    .honor-content {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .fg {
        width: 1px;
        height: 100%;
        background-color: #bbb;
      }
      .honor-item {
        text-align: center;
        width: 50%;
        li {
          a {
            display: inline-block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-decoration: none;
            color: #777;
            &:hover {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  /deep/ .el-tabs__nav-scroll {
    line-height: 50px !important;
    padding-top: 30px;
    .el-tabs__item {
      font-size: 30px;
    }
  }
  .cont-item {
    margin-bottom: 20px;
  }
  .cont-img {
    width: 44%;
    // img {
    //   height: 477px;
    // }
  }
  .cont-detail {
    width: 48%;
    margin-left: 6%;
    margin-right: 2%;
    h3 {
      font-size: 24px;
      line-height: 52px;
      letter-spacing: 3px;
      margin-bottom: 20px;
      &:before {
        // height: 24px;
        height: 45px;
        // top: 14px;
        top: 4px;
      }
    }
    .cont-title-left {
      // margin-left: 14px;
      &:before {
        // left: -14px;
        left: -20px;
      }
    }
    p {
      // font-size: 16px;
      // line-height: 25px;
      font-size: 18px;
      line-height: 32px;
      letter-spacing: 2px;
    }
  }
  .honor-item {
    font-size: 20px;
    line-height: 40px;
  }
}
@media screen and (min-width: 769px) and (max-width: 1200px) {
  /deep/ .el-tabs__nav-scroll {
    // line-height: 80px!important;
    line-height: 50px !important;
    padding-top: 20px;
    .el-tabs__item {
      font-size: 24px;
    }
  }
  //ipad pro
  .cont-item {
    margin-bottom: 4vh;
  }
  .cont-img {
    width: 44%;
    // img {
    //   height: 32vw;
    //   max-height: 477px;
    // }
  }
  .cont-detail {
    width: 48%;
    margin-left: 6%;
    margin-right: 2%;
    h3 {
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 3px;
      margin-bottom: 16px;
      &:before {
        height: 32px;
        top: 0px;
      }
    }
    .cont-title-left {
      // margin-left: 14px;
      &:before {
        left: -16px;
      }
    }
    p {
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 2px;
    }
  }
  .honor-item {
    font-size: 18px;
    line-height: 30px;
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  /deep/ .el-tabs__nav-scroll {
    line-height: 40px !important;
    .el-tabs__item {
      font-size: 18px;
    }
  }
  //ipad
  .cont-item {
    flex-wrap: wrap;
    margin-bottom: 4vh;
    .cont-img {
      width: 100%;
      // img {
      //   height: 34vw;
      //   max-height: 477px;
      // }
    }
    .cont-detail {
      width: 100%;
      h3 {
        font-size: 18px;
        line-height: 28px;
        letter-spacing: 2px;
        &:before {
          height: 24px;
          top: 2px;
        }
      }
      .cont-title-left {
        margin-left: 14px;
        margin-bottom: 10px;
        margin-top: 10px;
        &:before {
          left: -14px;
        }
      }
      p {
        font-size: 15px;
        line-height: 22px;
        letter-spacing: 2px;
      }
    }
  }
  .honor-item {
    font-size: 14px;
    line-height: 22px;
    li {
      padding: 0 4vw;
    }
  }
}
@media screen and (max-width: 413px) {
  /deep/ .el-tabs__nav-scroll {
    line-height: 30px !important;
    .el-tabs__item {
      font-size: 16px;
    }
  }

  //phone
  .cont-item {
    flex-wrap: wrap;
    margin-bottom: 4vh;
    .cont-img {
      width: 100%;
      // img {
      //   height: 34vw;
      //   max-height: 477px;
      // }
    }
    .cont-detail {
      width: 100%;
      h3 {
        font-size: 16px;
        line-height: 28px;
        &:before {
          height: 24px;
          top: 2px;
        }
      }
      .cont-title-left {
        margin-left: 14px;
        margin-bottom: 10px;
        margin-top: 10px;
        &:before {
          left: -12px;
        }
      }
      p {
        font-size: 13px;
        line-height: 18px;
        letter-spacing: 2px;
      }
    }
  }
  .honor-item {
    font-size: 14px;
    line-height: 20px;
    li {
      padding: 0 4vw;
    }
  }
}
</style>
